module.exports = __webpack_public_path__ + "e88aff9f8b5527d13725b8fd18452a1e.svg";